/** @format */

import systemErrorImg from "../../images/systemError.svg";
import { FormWrap } from "../../components/layouts/FormWrap";
import { ContentsWrapper } from "../../components/layouts/ContentsWrapper";
import { Container } from "../../components/layouts/Container";

const RedirectTimeout = () => {
  return (
    <Container>
      <ContentsWrapper>
        <FormWrap center>
          <img src={systemErrorImg} alt="systemErrorImg" />
          <h3>セッションタイムアウト</h3>
          <div className="mb32">
            <p className="font-m">セッションの有効期限が切れました。</p>
            <p className="font-m">はじめの画面より、再度アクセスをお願いします。</p>
          </div>
        </FormWrap>
      </ContentsWrapper>
    </Container>
  );
};

export default RedirectTimeout;
